import { Config } from "config/config.type"
/** @firescoutMockVar Config.config */
const config:Config = {
  "env": "prod",
  "location": "lusini_fr-ch",
  "shopName": "lusini",
  "locale": "fr-ch",
  "rootCategoryId": "EMG",
  "orderMinimumB2C": 20,
  "availableCreditCards": [
    "MASTERCARD",
    "VISA"
  ],
  "links": {
    "contact": "/aide-et-services/contactez-nous/"
  },
  "i18n": {
    "currency_ISO": "CHF",
    "locale": "fr-CH",
    "country": "CH"
  },
  "languages": {
    "de": "Allemand",
    "en": "Anglais",
    "fr": "Français",
    "es": "Espagnol",
    "it": "Italien",
    "nl": "Néerlandais",
    "pt": "Portugais",
    "sv": "Suédois",
    "da": "Danois",
    "nb": "Norvégien",
    "hr": "Croate"
  },
  "slugifyLocale": "fr",
  "curHrefLang": "fr-ch",
  "hrefLang": [
    {
      "configFolder": "lusini",
      "locale": "fr-ch",
      "hrefLang": "fr-ch"
    },
    {
      "configFolder": "lusini",
      "locale": "fr-be",
      "hrefLang": "fr-be"
    },
    {
      "configFolder": "lusini",
      "locale": "fr-fr",
      "hrefLang": "fr"
    }
  ],
  "baseUrl": "https://www.lusini.com",
  "functions": {
    "clientdata": "https://functions.lusini.com/.netlify/functions/clientdata",
    "newsletter": {
      "getOptInStatus": "https://functions.lusini.com/.netlify/functions/newsletter-getOptInStatus",
      "createContactWithOptIn": "https://functions.lusini.com/.netlify/functions/newsletter-createContactWithOptIn",
      "setOptInStatus": "https://functions.lusini.com/.netlify/functions/newsletter-setOptInStatus"
    },
    "creditsave": {
      "address": "https://functions.lusini.com/.netlify/functions/creditsafe-address"
    },
    "shareCart": {
      "POST": "https://functions.lusini.com/.netlify/functions/shareCart-POST",
      "GET": "https://functions.lusini.com/.netlify/functions/shareCart-GET"
    },
    "raffle": {
      "registration": "https://functions.lusini.com/.netlify/functions/POST-raffle-registration"
    }
  },
  "modules": {
    "onetrust": {
      "dataDomainScript": "bda0c016-94be-4fd9-943a-b9c09791a327"
    },
    "buzdev": {
      "errorUrl": "https://buz.lusini.com/webhook/com.lusini.commerce-platform/error/1-0-1"
    },
    "cloudinary": {
      "endpoint": "https://res.cloudinary.com/lusini/",
      "transformations": {
        "freisteller_l": "w_1500,h_1500,q_80,c_pad,f_auto",
        "freisteller_l_2": "w_1500,h_1500,q_80,c_pad,f_auto",
        "milieu_l": "w_1500,h_1500,g_auto,q_80,c_fill,f_auto",
        "milieu_l_2": "w_1500,h_1500,g_auto,q_80,c_fill,f_auto",
        "freisteller_m": "w_500,h_500,q_70,c_pad,f_auto",
        "freisteller_m_2": "w_500,h_500,q_70,c_pad,f_auto",
        "milieu_m": "ws_500,h_500,g_auto,q_70,c_fill,f_auto",
        "milieu_m_2": "ws_500,h_500,g_auto,q_70,c_fill,f_auto",
        "freisteller_s": "w_300,h_300,q_70,c_pad,f_auto",
        "freisteller_s_2": "w_600,h_600,q_70,c_pad,f_auto",
        "milieu_s": "w_300,h_300,g_auto,q_70,c_fill,f_auto",
        "milieu_s_2": "w_600,h_600,g_auto,q_70,c_fill,f_auto",
        "freisteller_xs": "w_50,h_50,q_50,c_pad,fl_lossy,f_auto",
        "freisteller_xs_2": "w_100,h_100,q_50,c_pad,fl_lossy,f_auto",
        "milieu_xs": "w_50,h_50,g_auto,q_50,c_fill,fl_lossy,f_auto",
        "milieu_xs_2": "w_100,h_100,g_auto,q_50,c_fill,fl_lossy,f_auto"
      },
      "fallback_product_picture": "https://res.cloudinary.com/lusini/image/upload/v1643182695/application/products/lusini-online-shop-platzhalter-produktbild-in-kuerze-fr.svg",
      "newsletter_intentlayer_picture": "https://res.cloudinary.com/lusini/image/upload/v1724665736/application/NewsletterPopupAB/discount-reduction-fr-ch.svg"
    },
    "shopware": {
      "salutations": [
        "mr",
        "ms",
        "not_specified"
      ],
      "initialSaluationId": "6d0b33d96b5b400cbabc648c0a4c3f60",
      "accessKey": {
        "b2b": "SWSC30KE09Q2GH2O75ME7K07VO",
        "b2c": "SWSCI3BE30S03QWFQ36PCPL6HS"
      },
      "storefrontUrl": {
        "b2b": "https://www.lusini.com/fr-ch/b2b",
        "b2c": "https://www.lusini.com/fr-ch/b2c"
      },
      "apiUrl": "https://shop-api.lusini.com/store-api",
      "languageId": "25453066e1ba49129e17110436aaf703"
    },
    "algolia": {
      "apiKey": "bf4bf9193d5f34cd369647376521dbc8",
      "applicationId": "WAVYBEW6OQ"
    },
    "contentful": {
      "space": "aza65graowyr",
      "environment": "master",
      "accessToken": "CiHQe6Rhx0nDcBT3Siv4qHIUk2xC6CcSwTbtIdMStyk",
      "previewToken": "J9M50p9PZokU9L3-SiDXcfDvVHpcTCzWyLSznbtHPWA"
    },
    "dyHybrid": {
      "apiKey": "36ac5fd76da488da1815369c11a826ac2cca1d12df164068917706c430418a29",
      "campaignID": "9879542"
    },
    "trustShop": {
      "placeholderImg": "https://res.cloudinary.com/lusini/image/upload/c_scale,w_100/v1670412947/application/icons/trusted-shops-guarantee.svg",
      "id": "X84AFDDDDE99B0E42D70AAD60CFFED39E",
      "url": "https://widgets.trustedshops.com/js/",
      "urlPostfix": ".js"
    },
    "zenloop": {
      "id": "WVdNd05EazBNamd0WXpZeVl5MDBPRGszTFRobE56QXROamswWkRBM1pHUTJZbU5o"
    },
    "hotjar": {
      "id": 3549008,
      "version": 6
    },
    "taboola": {
      "id": "1603278"
    }
  },
  "index": {
    "products": "prod_lusini_fr_CH_products",
    "productsPriceAsc": "prod_lusini_fr_CH_products_priceAsc",
    "productsPriceDesc": "prod_lusini_fr_CH_products_priceDesc",
    "categories": "prod_lusini_fr_CH_categories",
    "series": "prod_lusini_fr_CH_series",
    "productsSuggestion": "prod_lusini_fr_CH_products_query_suggestions",
    "productsLatest": "prod_lusini_fr_CH_products_noveltiesAsc",
    "productReviews": "prod_lusini_product_reviews",
    "serviceReviews": "prod_lusini_service_reviews"
  },
  "deliveryDate": {
    "shippingTooLong": 200
  },
  "colors": {
    "Blanc": "white",
    "Noir": "black",
    "Gris": "grey",
    "Argenté": "silver",
    "Brun": "brown",
    "Bleu": "blue",
    "Multicolore": "multicolor",
    "Rouge": "red",
    "Beige": "beige",
    "Vert": "green",
    "Transparent": "transparent",
    "Jaune": "yellow",
    "Doré": "gold",
    "Orange": "orange",
    "Rose/Lilas": "lilac"
  },
  "features": {
    "showProductRecommendationInfoTextB2B": true,
    "showProductRecommendationInfoTextB2C": true,
    "newsletterInitallyChecked": true,
    "onetrust": true,
    "devMode": false,
    "trustShop": true,
    "zenloop": true,
    "qrCode": false,
    "b2c": true,
    "userLikeWidgetUrl": "",
    "customizableUrl": "https://www.lusini.com/fr-ch/aide-et-services/nos-services/personnalisation/",
    "b2cHomePage": true,
    "taboola": true,
    "notificationBar": true,
    "showNewsletterIntentLayer": true,
    "leadinfo": true,
    "emarsysWebExtend": false,
    "emarsysWebExtendMerchantId": "1EE8D91037A93727",
    "cmpConsilius3dViewer": {
      "language": "fr"
    }
  },
  "langShop": {
    "current": {
      "language": "Language",
      "locale": "fr-CH",
      "label": "Français"
    },
    "alternate": [
      {
        "label": "deutsch",
        "url": "https://www.lusini.com/de-ch/",
        "active": false,
        "locale": "de-CH"
      },
      {
        "label": "français",
        "url": "https://www.lusini.com/fr-ch/",
        "active": true,
        "locale": "fr-CH"
      }
    ]
  },
  "abTests": {},
  "showTelephoneContactOnFailedCheckoutThreshold": 0
}
export default config